/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import { Alert, Button, Icon, Tag } from 'rsuite'
import firebase from 'firebase/app'
import { auth } from '../../misc/firebase'

export default function ProviderBlock() {

    // eslint-disable-next-line no-unused-vars
    const [isConnected, setIsConnected]= useState({

        'google.com': auth.currentUser.providerData.some((data)=>data.providerId==='google.com'),
        'facebook.com': auth.currentUser.providerData.some((data)=>data.providerId==='facebook.com')
    })

    const updateIsConnected =(providerId,value)=>{
        setIsConnected(p=> {
            return {
                ...p,
                [providerId]: value,
            };
        });
    };
    const unLink=async(providerId)=>{
 
        try {
            if(auth.currentUser.providerData.length===1){
                throw new Error(`You can not disconnect from ${providerId}`);
            }
            await auth.currentUser.unlink(providerId);
            updateIsConnected(providerId,false);
            Alert.info(`Disconnected from  ${providerId}`,4000);
        } catch (err) {
            Alert.error(err.message,4000);
            
        }
    }
    const unLinkGoogle=()=>{
        unLink('google.com');
    }
    const unLinkFacebook=()=>{
        unLink('facebook.com');
    }

     const link= async(provider)=>{
        try {
             await auth.currentUser.linkWithPopup(provider);
            Alert.info(`Connected with ${provider.providerId}`,4000);
            updateIsConnected(provider.providerId,true);
        } catch (err) {
            Alert.error(err.message,4000);
        }
     }

    const linkGoogle=()=>{
        link( new firebase.auth.GoogleAuthProvider());
    }
    const linkFacebook=()=>{
        link( new firebase.auth.FacebookAuthProvider());
    }
    return (
        <div>
            {isConnected['google.com'] &&
            <Tag color='green' closable onClose={unLinkGoogle}>
                <Icon icon='google'/> Connected
            </Tag>
            }
            {isConnected['facebook.com'] &&
            <Tag color='blue' closable onClose={unLinkFacebook}>
                <Icon icon='facebook'/> Connected
            </Tag>
            }
            <div className='mt-2'>
            {!isConnected['google.com'] &&
                <Button color='green' block onClick={linkGoogle}>
                  <Icon icon='google'/> Link to google
                </Button>
            }

            {!isConnected['facebook.com'] &&
                <Button color='blue' block onClick={linkFacebook}>
                  <Icon icon='facebook'/> Link to facebook
                </Button>
            }
            </div>
        </div>
    )
}
